import { ItemList } from '../../orm'

class AdminEditableEmailList extends ItemList {
    getEntityKey() {
        return "admin/editable_email"
    }
}

export const adminEditableEmailList = new AdminEditableEmailList("admin_editable_email__default")

// Manual (admin authored) emails are the same resource; they have their own page and are separated
// with an is_manual filter. A separate list key keeps their filter and pagination state independent
// of the catalogue list above.
export const adminManualEditableEmailList = new AdminEditableEmailList("admin_manual_editable_email__default")

class AdminManualEditableEmailCreateList extends ItemList {
    getEntityKey() {
        return "admin/editable_email/create_manual"
    }
}

export const adminManualEditableEmailCreateList = new AdminManualEditableEmailCreateList("admin_manual_editable_email_create__default")

class AdminManualEditableEmailDeleteList extends ItemList {
    getEntityKey() {
        return "admin/editable_email/delete_manual"
    }
}

export const adminManualEditableEmailDeleteList = new AdminManualEditableEmailDeleteList("admin_manual_editable_email_delete__default")
